export default "<button type=\"button\" class=\"btn btn-primary\">\r\n  Single Button\r\n</button>\r\n";